import axios from '../api/BaseURL'
import authHeader from './auth-header'

class employeeAPI {
  // create
  createEmployee(data) {
    return axios.post('/employee/registration', data, { headers: authHeader() })
  }
  // create
  createEmployeeUser(data) {
    return axios.post('/user/registration', data, { headers: authHeader() })
  }
  // assign customer
  assignCustomer(data) {
    return axios.put('/employee-customer-assign/assignCustomer', data, {
      headers: authHeader(),
    })
  }

  // list
  getList() {
    return axios.get('/user/list', { headers: authHeader() })
  }
  // list => unassign customer
  getUnassignList() {
    return axios.get('/employee-customer-assign/listOfUnAssignedCustomers', {
      headers: authHeader(),
    })
  }
  // list => Assigned customer
  getAssignList(id) {
    return axios.get(
      '/employee-customer-assign/listOfAssignedCustomers/' + id,
      {
        headers: authHeader(),
      },
    )
  }
  // update

  // delete
  deleteEmployee(id) {
    return axios.post(
      '/user/deleteEmployee',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    )
  }

  // change status
  changeStatus(id) {
    return axios.post(
      '/user/changeEmployeeStatus',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    )
  }

  // update
  updateEmployee(data) {
    return axios.put('/user/profile/update', data, {
      headers: authHeader(),
    })
  }

  // reset password
  resetPassword(id) {
    return axios.post(
      '/user/resetPassword',
      {
        id: id,
      },
      {
        headers: authHeader(),
      },
    )
  }
}
export default new employeeAPI()
